<mat-form-field style="width: 100%" [formGroup]="form">
    <input matInput [placeholder]="item.label" [matAutocomplete]="auto" [formControlName]="item.name"  (change)="handleEmptyInput($event)" [required]="item.required">
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="valueMapper" (optionSelected)="onSelected($event)">
      <mat-option *ngFor="let opt of filteredOptions | async" [value]="opt.data" (click)="matInput.value=''">
        {{opt.label}}
      </mat-option>
    </mat-autocomplete>
</mat-form-field>